import { useTranslation } from "react-i18next";
import { WhatsAppChatButton } from "./WhatsAppChatButton";
import { TelegramChatButton } from "./TelegramChatButton";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ExternalChatButtonProps {
  recipientId: string;
  recipientName: string;
  recipientPhone?: string | null;
  recipientTelegram?: string | null;
  whatsappEnabled?: boolean;
  telegramEnabled?: boolean;
  preferredPlatform?: string | null;
  messageContext?: string;
}

export const ExternalChatButton = ({
  recipientName,
  recipientPhone,
  recipientTelegram,
  whatsappEnabled,
  telegramEnabled,
  preferredPlatform = "none",
  messageContext = "supervision",
}: ExternalChatButtonProps) => {
  const { t } = useTranslation();
  
  // Vérifier si au moins une plateforme est disponible
  const hasWhatsApp = whatsappEnabled && recipientPhone;
  const hasTelegram = telegramEnabled && recipientTelegram;

  // Logs de débogage
  console.log("ExternalChatButton props:", {
    recipientName,
    recipientPhone,
    recipientTelegram,
    whatsappEnabled,
    telegramEnabled,
    preferredPlatform,
    hasWhatsApp,
    hasTelegram
  });

  // Si aucune plateforme n'est configurée
  if (!hasWhatsApp && !hasTelegram) {
    return (
      <Alert variant="destructive" className="max-w-md">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          {t("contact.noMessagingConfigured")}
        </AlertDescription>
      </Alert>
    );
  }

  // Afficher selon la plateforme préférée
  if (preferredPlatform === "whatsapp" && hasWhatsApp) {
    return (
      <WhatsAppChatButton
        phoneNumber={recipientPhone!}
        recipientName={recipientName}
        messageContext={messageContext}
        size="sm"
      />
    );
  }

  if (preferredPlatform === "telegram" && hasTelegram) {
    return (
      <TelegramChatButton
        username={recipientTelegram!}
        recipientName={recipientName}
        size="sm"
      />
    );
  }

  // Si "both" est sélectionné ou si la plateforme préférée n'est pas disponible
  return (
    <div className="flex gap-2">
      {hasWhatsApp && (
        <WhatsAppChatButton
          phoneNumber={recipientPhone!}
          recipientName={recipientName}
          messageContext={messageContext}
          size="sm"
        />
      )}
      {hasTelegram && (
        <TelegramChatButton
          username={recipientTelegram!}
          recipientName={recipientName}
          size="sm"
        />
      )}
    </div>
  );
};